import { CacheAreaKey } from 'core/config/cache-config';
import { StorageHelper } from 'core/services/storage';
import { AnalyticsAcquisitionModel } from '../constants/analytics-journey';
import { UtmTypes } from '../enums/analytics-journey-key';

const localWindow = window as any;

export class DataLayerStore {
  private static dataLayerStore: DataLayerStore;

  private countryCode!: string;
  private languageCode!: string;

  private constructor() {
  }

  public static get GetInstance() {
    if (!this.dataLayerStore) {
      this.dataLayerStore = new DataLayerStore();
    }

    return this.dataLayerStore;
  }

  initialize(countryCode: string, languageCode: string) {
    this.countryCode = countryCode;
    this.languageCode = languageCode;

    return this;
  }

  getAcquisitionTags(queryString: URLSearchParams) {
    const campaign_source = queryString.get(UtmTypes.Source);
    const campaign_medium = queryString.get(UtmTypes.Medium);
    const campaign_name = queryString.get(UtmTypes.Campaign);
    const campaign_content = queryString.get(UtmTypes.Content);
    const campaign_term = queryString.get(UtmTypes.Term);

    return {
      campaign_name,
      campaign_medium,
      campaign_source,
      campaign_content,
      campaign_term,
    } as AnalyticsAcquisitionModel;
  }

  getAcquisitionData() {
    const acquisitionData = localWindow.mcgDataLayer?.acquisition as AnalyticsAcquisitionModel;
    const storedAcquisition = StorageHelper.GetInstance.getFromCache('analytics', 'UTM_CAMPAIGN', CacheAreaKey.Analytics) as AnalyticsAcquisitionModel

    return acquisitionData || storedAcquisition || undefined;
  }

  setAcquisitionData(acquisitionData?: AnalyticsAcquisitionModel) {
    if (acquisitionData) {
      StorageHelper.GetInstance.setCacheAndReturn(
        'analytics',
        CacheAreaKey.Analytics,
        acquisitionData,
        'UTM_CAMPAIGN'
      );
    }

    const newAcquisitionData = acquisitionData || this.getAcquisitionData();

    this.set({ acquisition: newAcquisitionData });
  }

  set(data?: any) {
    if (!localWindow.mcgDataLayer) {
      localWindow.mcgDataLayer = this.getDefaultDataLayer();
    }

    if (!data) {
      return;
    }

    localWindow.mcgDataLayer = {
      ...localWindow.mcgDataLayer,
      ...data
    };
  }

  getDefaultDataLayer() {
    const { pathname } = window.location;
    const pageName = pathname.replace('/', ':');
    const pathNames = pathname.split('/');
    const pageSection = pathNames.findLast(path => path.length > 2);
    const platformType = /Mobile/i.test(navigator.userAgent) ? 'mobile web' : 'desktop web'

    return {
      page: {
        page_name: pageName,
        page_section: pageSection,
        page_type: 'generic',
        page_url: window.location.href,
      },
      user: {
        user_id: '',
        hashed_email: '',
        connect_id: '',
        segment_id: '',
        billing_id: '',
        subscriber_type: '',
        login_type: '',
      },
      article: {
        article_name: '',
        article_category: '',
        article_published_date: '',
        article_id: '',
      },
      acquisition: {
        // campaign_name: '',
        // campaign_source: '',
        // campaign_medium: '',
        // campaign_content: '',
        // campaign_term: '',
        // business_unit: '',
        // referral_url: '',
      },
      interaction: {
        component_name: '',
        component_type: '',
        category: '',
        location: '',
        target_page_url: '',
      },
      search: {
        search_type: 'global search',
        filter_term: '',
        search_term: '',
        num_search_results: '',
        search_count: '',
      },
      content: {
        content_type: 'general page',
        content_title: '',
        content_tag: '',
        content_category: '',
      },
      ecommerce: {
        event: '',
        products: [],
      },
      platform: {
        platform_name: 'uni-web',
        platform_type: platformType,
        platform_language: this.languageCode,
        country_code: this.countryCode,
      },
      error: {
        error_code: '',
        error_type: '',
        error_message: '',
        error_count: '',
      }
    }
  }
}
